/* Product page — 2026 design ("v4"). Loaded only when the main product
   section's "Page design" is set to New design.

   Adds to the theme's own gallery, without replacing any of it:
     · previous / next arrows on the main photo
     · a "1 / 14" counter
     · a "+N" tile after the sixth thumbnail that opens the full-screen viewer
   Everything works by pressing the theme's own thumbnails and its own
   expand button, so variant switching, zoom and video keep working as before.
   Also wires the coupon "Copy" button.
   Ported from the Bidets USA theme (Oct 2026). */
(function () {
  'use strict';
  var MAX_THUMBS = 7; // tiles in one row on desktop, counting the "+N" tile

  function svg(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '"/></svg>';
  }

  function initGallery(gallery) {
    if (!gallery || gallery.getAttribute('data-pdp4') === '1') return;
    var viewer = gallery.querySelector('[data-gallery-viewer]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    if (!viewer || thumbs.length < 2) return;
    gallery.setAttribute('data-pdp4', '1');

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-gallery-selected') === 'true') return i;
      }
      return 0;
    }
    function go(step) {
      var n = thumbs.length;
      var next = thumbs[(current() + step + n) % n];
      if (next) next.click();
    }

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pdp4-arrow pdp4-arrow--prev';
    prev.setAttribute('aria-label', 'Previous photo');
    prev.innerHTML = svg('M15 18l-6-6 6-6');
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'pdp4-arrow pdp4-arrow--next';
    next.setAttribute('aria-label', 'Next photo');
    next.innerHTML = svg('M9 18l6-6-6-6');
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    var count = document.createElement('div');
    count.className = 'pdp4-count';
    count.setAttribute('aria-hidden', 'true');

    viewer.appendChild(prev);
    viewer.appendChild(next);
    viewer.appendChild(count);

    function paint() { count.textContent = (current() + 1) + ' / ' + thumbs.length; }
    paint();
    if (window.MutationObserver) {
      var mo = new MutationObserver(paint);
      thumbs.forEach(function (t) {
        mo.observe(t, { attributes: true, attributeFilter: ['data-gallery-selected'] });
      });
    }

    // "+N" tile: only when there are more photos than fit in one row
    var scroller = gallery.querySelector('[data-gallery-scroller]');
    var expand = gallery.querySelector('[data-gallery-expand]');
    if (scroller && thumbs.length > MAX_THUMBS && expand) {
      scroller.classList.add('pdp4-has-more');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'pdp4-more';
      var hidden = thumbs.length - (MAX_THUMBS - 1);
      more.textContent = '+' + hidden;
      more.setAttribute('aria-label', 'View all ' + thumbs.length + ' photos');
      more.addEventListener('click', function (e) { e.preventDefault(); expand.click(); });
      scroller.appendChild(more);
    }
  }

  // "Brand | SKU | reviews": the three sit on one line when they fit. If one
  // has to drop to the next line, mark it so its divider is not left hanging
  // at the start of that line.
  function initMeta(details) {
    if (!details || details.getAttribute('data-pdp4-meta') === '1') return;
    details.setAttribute('data-pdp4-meta', '1');
    var busy = false;
    function check() {
      if (busy) return;
      busy = true;
      // a brand with no brand collection prints an empty vendor line: hide it
      // so no divider is left hanging
      [].slice.call(details.querySelectorAll(':scope > .product-block--vendor, :scope > .product-block--sku')).forEach(function (el) {
        el.classList.toggle('pdp4-empty', !(el.textContent || '').trim());
      });
      var items = [].slice.call(details.children).filter(function (el) {
        return el.classList.contains('product-block--vendor') ||
               el.classList.contains('product-block--sku') ||
               el.classList.contains('pdp4-meta');
      }).filter(function (el) { return el.offsetHeight > 0; })
        .sort(function (a, b) {
          return (parseInt(getComputedStyle(a).order, 10) || 0) - (parseInt(getComputedStyle(b).order, 10) || 0);
        });
      // an item has wrapped when it starts below the bottom of the one before
      // it (items on the same line overlap vertically, whatever their heights)
      var prev = null;
      items.forEach(function (el, i) {
        var wrapped = i > 0 && prev !== null && el.offsetTop >= prev.offsetTop + prev.offsetHeight - 2;
        el.classList.toggle('pdp4-wrapped', wrapped);
        prev = el;
      });
      busy = false;
    }
    check();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(check);
      ro.observe(details);
      [].slice.call(details.querySelectorAll('.pdp4-meta')).forEach(function (el) { ro.observe(el); });
    } else {
      window.addEventListener('resize', check);
    }
    window.addEventListener('load', check);
    setTimeout(check, 1500);
    setTimeout(check, 4000);
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('.pdp-v4 [data-product-gallery]')).forEach(initGallery);
    [].slice.call(document.querySelectorAll('.pdp-v4 .product-details')).forEach(initMeta);
  }

  // coupon: one listener for the page
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pdp4-copy]') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-pdp4-copy');
    var root = btn.closest('.pdp4-coupon');
    var labels = [].slice.call(btn.querySelectorAll('span'));
    var original = labels.map(function (s) { return s.textContent; });
    function done() {
      if (root) root.classList.add('is-copied');
      labels.forEach(function (s) { s.textContent = 'Copied'; });
      setTimeout(function () {
        if (root) root.classList.remove('is-copied');
        labels.forEach(function (s, i) { s.textContent = original[i]; });
      }, 1600);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else { fallback(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();